
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockApproveSetAssembleDtDialog extends Serenity.Extensions.GridEditorDialog<IcStockApproveSetAssembleDtRow> {
        // protected getFormKey() { return IcStockApproveSetAssembleDtForm.formKey; }
        // protected getIdProperty() { return IcStockApproveSetAssembleDtRow.idProperty; }
        protected getLocalTextPrefix() { return IcStockApproveSetAssembleDtRow.localTextPrefix; }
        protected getNameProperty() { return IcStockApproveSetAssembleDtRow.nameProperty; }
        // protected getService() { return IcStockApproveSetAssembleDtService.baseUrl; }
        // protected getDeletePermission() { return IcStockApproveSetAssembleDtRow.deletePermission; }
        // protected getInsertPermission() { return IcStockApproveSetAssembleDtRow.insertPermission; }
        // protected getUpdatePermission() { return IcStockApproveSetAssembleDtRow.updatePermission; }

        protected form = new IcStockApproveSetAssembleDtForm(this.idPrefix);

    }
}